import SwiperCore, { EffectFade, Navigation } from 'swiper/core';

SwiperCore.use([EffectFade, Navigation]);

export default {
  init() {
    const sliders = document.querySelectorAll('.swiper-container');
    if (sliders) {
      sliders.forEach(sld => {
        const selector = sld as HTMLElement;
        const swiper = new SwiperCore(selector, {
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          speed: 600,
          navigation: {
            nextEl: `#${selector.dataset.nextId}`,
            prevEl: `#${selector.dataset.prevId}`
          }
        });
      });
    }
  }
};
